<script>
  import Container from '@/library/container/full-centre.svelte';
</script>

<div class="z-50 absolute h-screen w-full">
  <Container>
    <slot></slot>
  </Container>
</div>